import type { OS } from '#dn-types/downloads.ts';

export function buildDownloadCommand(os: OS, url?: string) {
  if (!url) return;

  const cmd = os === 'windows' ? 'curl.exe -O' : 'curl -O';
  return `${cmd} ${url}`;
}
